import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: 'input[appNumbersOnly]',
  standalone: false
})
export class NumbersOnlyDirective {
  private elementRef = inject(ElementRef);

  constructor() { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initialValue: string = this.elementRef.nativeElement.value;
    this.elementRef.nativeElement.value = initialValue.replace(/[^0-9]*/g, '');
    if (initialValue !== this.elementRef.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
